import React from "react";
import { Outlet } from "react-router-dom";
import TopNav from "@/components/wedding/TopNav";
import DemoBanner from "@/components/wedding/DemoBanner";

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col" data-testid="app-layout">
      <DemoBanner />
      <TopNav />
      <div className="flex-1">
        <Outlet />
      </div>
      <footer className="text-center py-8" data-testid="footer">
        <p className="font-script-alt text-2xl text-[color:var(--ink-wine)]">Selena & Mario</p>
        <p className="text-[0.65rem] tracking-[0.3em] uppercase text-[color:var(--ink-wine)]/60 mt-1">
          18 · 07 · 2026 · Mirador de les Caves
        </p>
      </footer>
    </div>
  );
}
